import { MOTTO } from "@/data/brothers";

export default function CharismSection() {
  return (
    <section className="py-24 sm:py-32 bg-brand-bg" data-testid="charism-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-brand-terracotta text-sm uppercase tracking-[0.2em] font-semibold mb-4">
          Our Charism
        </p>
        <h2 className="font-serif text-3xl sm:text-5xl text-brand-ink leading-tight mb-6">
          A Calling of Presence
        </h2>
        <p className="text-brand-muted text-lg leading-relaxed mb-6">
          The Josephians are constituted as a private association of the faithful through the diocese of Pensacola-Tallahassee. We are called to seek Christ our Universal Brother hidden among the condemned, through contemplative and merciful accompaniment.
        </p>
        <p className="text-brand-muted leading-relaxed">
          We take Joseph as our model — the quiet, faithful protector who built a home
          for the vulnerable and asked for no recognition. Our motto,
          <span className="font-serif italic text-brand-ink"> &quot;{MOTTO}&quot; </span>
          — to seek the hidden Christ — names the whole of our work: to find Him in the ones
          the world forgets.
        </p>
      </div>
    </section>
  );
}
